import {anyPass, equals, filter, firstOf, flow, get, identity, ifThen, isFilled, map} from '@yandex-delivery/utils'

import type {UserStep, UserSteps} from '../../../model/registration'
import type {TicketStateResponse} from '../../../repo/cargo-crm/types'
import type {TicketFlow} from '../types'

const isKnownStep: (awaitedSteps: string[]) => boolean = anyPass([
  equals('company_info_form'),
  equals('reveal_corp_client'),
])

function fromAwaitedSteps(response: TicketStateResponse): UserSteps | undefined {
  const _fromAwaitedSteps: (response: TicketStateResponse) => UserSteps | undefined = flow(
    get('progress.awaited_steps'),
    // маппим шаги бекенда в известные шаги фронта
    map(ifThen(isKnownStep, identity)),
    filter<UserStep>(Boolean),
    ifThen(isFilled, identity),
  )
  return _fromAwaitedSteps(response)
}

const fromClientID: (response: TicketStateResponse) => UserSteps | undefined = flow(
  get('forms.company_created_form.corp_client_id'),
  function _fromClientID(clientID?: string): UserSteps | undefined {
    return clientID ? ['finish_registration'] : undefined
  },
)

const toUserSteps: (response: TicketStateResponse) => UserSteps | undefined = firstOf(
  ifThen(flow(get('is_enter_enabled'), Boolean), fromClientID),
  fromAwaitedSteps,
)

export {toUserSteps}

export function toTicketFlow(ticketID: string) {
  function _toTicketFlow(response: TicketStateResponse): TicketFlow {
    const userSteps = toUserSteps(response)

    return {
      ticketID,
      ticketState: response,
      userSteps,
    }
  }

  return _toTicketFlow
}
